// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"0bc61fa3","412":"5df57c92","464":"40a73293","550":"fb32251c","768":"f2d9204d","799":"963c8bf4"}[chunkId] + ".chunk.js";
};